import i18next from "src/i18n/config";
import RouteService from "src/services/routeService";
import { transformErrorResponse } from "src/store/helpers";
import { ApiResponse } from "src/types";

import { AdminBuilder } from "./tags";

const products = (builder: AdminBuilder) => ({
    getAllProducts: builder.query<API.Product[], void>({
        providesTags: ["AdminProducts"],
        transformErrorResponse: (err) => transformErrorResponse(err, i18next.t("common:error.products.failedToFetchProducts")),
        transformResponse: (response: ApiResponse<API.Product[]>) => response.model,
        query: async () => {
            const base = await RouteService.getProductRoute();
            return { url: `${base}products/all` };
        },
    }),
});

export default products;
